const helpers = require('./helpers.js');

('use strict');

///////////////////////////////////////////////////////
// THINGS TO CHANGE DURING DEVELOPMENT
///////////////////////////////////////////////////////
//  //IN SCRIPT>JS FOR SERVERURL
//      var SERVERURL = 'http://localhost:3000'; - USE FOR TESTING SERVER CODE
//        OR
//      var SERVERURL = 'https://safe-journey-35449.herokuapp.com'; - USE FOR RELEASE

//  //IN GUESTBOOK.JS CLIENT URL
//      url: 'http://127.0.0.1:3000/api/v1/guestbooks', - USE FOR TESTING SERFER CODE
//        OR;
//      url: 'https://safe-journey-35449.herokuapp.com', - USE FOR RELEASE
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// GLOBAL FUNCTIONS DEFINED BELOW
// window.loadBufferImage = loadBufferImage;
// window.patchTrip = patchTrip;
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// STANDARD RECIPE ITEMS FOR PACKING CODE FOR OLDER BROWSERS
// Does not trigger a re-load when saving
if (module.hot) {
  module.hot.accept();
}

// Polyfill for code translation if needed
import 'core-js/stable';

// Polyfill async functions
import 'regenerator-runtime/runtime';

// Add this right after the imports
const isMobile = window.matchMedia('(max-width: 768px)').matches;

// For performing API requests
const axios = require('axios');

const SMALLIMAGERESOLUTION = isMobile ? 450 : 600;

const SERVERURL = 'https://safe-journey-35449.herokuapp.com';

// Global flag
let guestbookShown = false;

// Cache for year trips HTML to avoid re-fetching
const yearTripsCache = {};

// Global array of trips information from Trips database
window.tripsList = []; // Changed from string to empty array

// Prevent scrolling of the accordion and modal content
document.addEventListener('DOMContentLoaded', function () {
  // Allow vertical scrolling on body
  document.documentElement.style.overflowY = 'auto';
  document.body.style.overflowY = 'auto';
  // Prevent horizontal scrolling
  document.documentElement.style.overflowX = 'hidden';
  document.body.style.overflowX = 'hidden';

  // Ensure trip data loads on startup
  getTripData('');
});

/////////////////////////////////////////////////////
// Code for Accordian operation
// Helper to close an accordion item
function closeAccordionItem(item) {
  // Reset class
  item.className = 'item';
  // Reset arrow icon to down
  const icon = item.querySelector('.icon');
  if (icon && icon.firstElementChild) {
    icon.firstElementChild.setAttribute('d', 'M19 9l-7 7-7-7');
  }
  // Hide scroll buttons
  const rightButton = item.getElementsByClassName('btn--right');
  const leftButton = item.getElementsByClassName('btn--left');
  if (rightButton[0]) {
    rightButton[0].setAttribute('class', 'hide btn btn--right');
  }
  if (leftButton[0]) {
    leftButton[0].setAttribute('class', 'hide btn btn--left');
  }
}

// Returns a combined note string for all currently visible photos
function getTripNoteText(trip, startIndex) {
  const count = isMobile ? 1 : 3;
  const parts = [];
  for (
    let i = startIndex;
    i < Math.min(startIndex + count, trip.photoId.length);
    i++
  ) {
    if (trip.notes && trip.notes[i]) parts.push(trip.notes[i]);
  }
  return parts.join('  |  ');
}

// Returns note text, or '' if empty/null/"none"
function getNoteText(notes, index) {
  const val = notes && notes[index];
  if (!val || val.trim().toLowerCase() === 'none') return '';
  return val;
}

/////////////////////////////////////////////////////
/*Handle mouse clicks on LEFT image scroll buttons*/
// Handlers are initialized after trips are loaded
function wireScrollLeftClick(item, tripsIndex) {
  const index = tripsIndex;
  item.addEventListener('click', async function () {
    const photoDat = window.tripsList[index];
    const hiddenBoxParent = item.parentNode;
    const allImages = hiddenBoxParent.querySelectorAll('img', '.photo');
    const nItems = photoDat.files.length;
    const scrollAmount = 1;

    // Scroll images to the right by moving index to left
    if (photoDat.index > 0) {
      photoDat.index = photoDat.index - scrollAmount;
    }

    // Check if CURRENT image is loaded - if not, show spinner and wait
    if (photoDat.photoBufferLocal[photoDat.index] === 0) {
      spinner.style.display = 'block';
      await loadBufferImage(
        photoDat.photoId[photoDat.index],
        photoDat,
        photoDat.index,
        SMALLIMAGERESOLUTION,
        'local',
      );
      spinner.style.display = 'none';
    }

    // Update display immediately
    setHTMLImgBuffers(allImages, photoDat.photoBufferLocal, photoDat.index);

    // Update note overlays for visible photos
    const photoNotesL = hiddenBoxParent.querySelectorAll('.photo-note');
    photoNotesL.forEach((noteEl, i) => {
      noteEl.textContent = getNoteText(photoDat.notes, photoDat.index + i);
    });

    // Background preload (non-blocking)
    if (
      photoDat.index > 0 &&
      photoDat.photoBufferLocal[photoDat.index - 1] === 0
    ) {
      loadBufferImage(
        photoDat.photoId[photoDat.index - 1],
        photoDat,
        photoDat.index - 1,
        SMALLIMAGERESOLUTION,
        'local',
      );
    }
    if (
      photoDat.index < nItems - 1 &&
      photoDat.photoBufferLocal[photoDat.index + 1] === 0
    ) {
      loadBufferImage(
        photoDat.photoId[photoDat.index + 1],
        photoDat,
        photoDat.index + 1,
        SMALLIMAGERESOLUTION,
        'local',
      );
    }

    // Hide/Show scroll button
    const rightButton = hiddenBoxParent.getElementsByClassName('btn--right');
    const leftButton = hiddenBoxParent.getElementsByClassName('btn--left');
    adjustScrollBtnVisability(leftButton, rightButton, photoDat.index, nItems);
  });
}

/* Handle mouse click on RIGHT image scroll button*/
function wireScrollRtClick(item, tripsIndex) {
  const index = tripsIndex;
  item.addEventListener('click', async function () {
    const photoDat = window.tripsList[index];
    const hiddenBoxParent = item.parentNode;
    const allImages = hiddenBoxParent.querySelectorAll('img', '.photo');
    const nItems = photoDat.files.length;
    const scrollAmount = 1;
    const photosPerView = isMobile ? 1 : 3;

    // Scroll images to the left by moving index to the right
    if (photoDat.index < nItems - photosPerView) {
      photoDat.index = photoDat.index + scrollAmount;
    } else {
      return;
    }

    // Check if CURRENT image is loaded - if not, show spinner and wait
    if (photoDat.photoBufferLocal[photoDat.index] === 0) {
      spinner.style.display = 'block';
      await loadBufferImage(
        photoDat.photoId[photoDat.index],
        photoDat,
        photoDat.index,
        SMALLIMAGERESOLUTION,
        'local',
      );
      spinner.style.display = 'none';
    }

    // Update display immediately
    setHTMLImgBuffers(allImages, photoDat.photoBufferLocal, photoDat.index);

    // Update note overlays for visible photos
    const photoNotesR = hiddenBoxParent.querySelectorAll('.photo-note');
    photoNotesR.forEach((noteEl, i) => {
      noteEl.textContent = getNoteText(photoDat.notes, photoDat.index + i);
    });

    // Background preload (non-blocking) - load ahead without waiting
    if (
      photoDat.index > 0 &&
      photoDat.photoBufferLocal[photoDat.index - 1] === 0
    ) {
      loadBufferImage(
        photoDat.photoId[photoDat.index - 1],
        photoDat,
        photoDat.index - 1,
        SMALLIMAGERESOLUTION,
        'local',
      );
    }
    if (
      photoDat.index < nItems - 1 &&
      photoDat.photoBufferLocal[photoDat.index + 1] === 0
    ) {
      loadBufferImage(
        photoDat.photoId[photoDat.index + 1],
        photoDat,
        photoDat.index + 1,
        SMALLIMAGERESOLUTION,
        'local',
      );
    }
    if (
      photoDat.index < nItems - 2 &&
      photoDat.photoBufferLocal[photoDat.index + 2] === 0
    ) {
      loadBufferImage(
        photoDat.photoId[photoDat.index + 2],
        photoDat,
        photoDat.index + 2,
        SMALLIMAGERESOLUTION,
        'local',
      );
    }

    // Hide/Show scroll button
    const rightButton = hiddenBoxParent.getElementsByClassName('btn--right');
    const leftButton = hiddenBoxParent.getElementsByClassName('btn--left');

    adjustScrollBtnVisability(leftButton, rightButton, photoDat.index, nItems);

    // Show guestbook after scrolling (desktop only)
    if (guestbookShown === false && !isMobile) {
      const guestBook = document.getElementById('guestBook');
      guestBook.style.display = 'block';
      guestbookShown = true;
    }
  });
}

// Adjust visibility of scroll buttons based on current index and number of items
function adjustScrollBtnVisability(
  leftButton,
  rightButton,
  startIndex,
  nItems,
) {
  const rb = rightButton && rightButton[0];
  const lb = leftButton && leftButton[0];

  // Always start with both buttons visible
  if (rb) {
    rb.setAttribute('class', 'btn btn--right');
    rb.style.display = 'block';
    rb.style.zIndex = '11';
  }
  if (lb) {
    lb.setAttribute('class', 'btn btn--left');
    lb.style.display = 'block';
    lb.style.zIndex = '11';
  }

  const photosPerView = isMobile ? 1 : 3;

  // If not enough photos to scroll, hide both buttons
  if (nItems <= photosPerView) {
    if (lb) {
      lb.setAttribute('class', 'hide btn btn--left');
      lb.style.display = 'none';
      lb.style.zIndex = '';
    }
    if (rb) {
      rb.setAttribute('class', 'hide btn btn--right');
      rb.style.display = 'none';
      rb.style.zIndex = '';
    }
    return;
  }

  // Hide left button if at first image
  if (startIndex === 0) {
    if (lb) {
      lb.setAttribute('class', 'hide btn btn--left');
      lb.style.display = 'none';
      lb.style.zIndex = '';
    }
  }

  // Hide right button if at last image (mobile) or last scrollable set (desktop)
  if (isMobile) {
    if (startIndex >= nItems - 1) {
      if (rb) {
        rb.setAttribute('class', 'hide btn btn--right');
        rb.style.display = 'none';
        rb.style.zIndex = '';
      }
    }
  } else {
    if (startIndex >= nItems - photosPerView) {
      if (rb) {
        rb.setAttribute('class', 'hide btn btn--right');
        rb.style.display = 'none';
        rb.style.zIndex = '';
      }
    }
  }
}

// Assign image buffers to trip html elements - SIMPLIFIED
function setHTMLImgBuffers(htmlElements, photoBufferLocal, startIndex) {
  if (isMobile) {
    // Mobile: Only 1 image element exists, just update it
    const img = htmlElements[0];
    if (img && photoBufferLocal[startIndex]) {
      img.setAttribute(
        'src',
        `data:image/jpeg;base64,${photoBufferLocal[startIndex]}`,
      );
      img.setAttribute(
        'alt',
        `${helpers.getTripNumber(img.getAttribute('alt'))},${startIndex}`,
      );
    }
  } else {
    // Desktop: 3 image elements exist, update all 3
    htmlElements.forEach((img, idx) => {
      if (img && photoBufferLocal[startIndex + idx]) {
        img.setAttribute(
          'src',
          `data:image/jpeg;base64,${photoBufferLocal[startIndex + idx]}`,
        );
        img.setAttribute(
          'alt',
          `${helpers.getTripNumber(htmlElements[0].getAttribute('alt'))},${
            startIndex + idx
          }`,
        );
      }
    });
  }
}

// Set up event listeners for Open/Close buttons
function wireOpenCloseBtn(item) {
  item.addEventListener('click', function () {
    // Get parent of SVG element (<div class="item")
    const svg_parent = item.parentNode;

    const rightButton = svg_parent.getElementsByClassName('btn--right');
    const leftButton = svg_parent.getElementsByClassName('btn--left');
    const allImgs = svg_parent.querySelectorAll('.photo');

    // Safety check: ensure we have images and tripsList is loaded
    if (
      !allImgs ||
      allImgs.length === 0 ||
      !window.tripsList ||
      window.tripsList.length === 0
    ) {
      return;
    }

    const photoAlt = allImgs[0].alt;
    const tripNumber = helpers.getTripNumber(photoAlt);
    const openTrip = window.tripsList[tripNumber];
    const allItems = document.querySelectorAll('.item');

    // Toggle icon from up to down or vice versa
    const childPath = item.firstElementChild;
    if (childPath.getAttributeNS(null, 'd') === 'M19 9l-7 7-7-7') {
      // Icon is down, change to up, Open accordion section
      // Make sure all othe accordians are closed and down
      for (let i = 0; i < allItems.length; i++) {
        closeAccordionItem(allItems[i]);
      }

      childPath.setAttribute('d', 'M5 15l7-7 7 7');
      svg_parent.setAttribute('class', 'item open');

      // Reset trip index to 0 when opening
      if (openTrip && typeof openTrip === 'object') {
        openTrip.index = 0;
        // Update display to show image at index 0 (works for both mobile and desktop now)
        setHTMLImgBuffers(allImgs, openTrip.photoBufferLocal, 0);

        // Reset note overlays for visible photos
        const photoNotesOpen = svg_parent.querySelectorAll('.photo-note');
        photoNotesOpen.forEach((noteEl, i) => {
          noteEl.textContent = getNoteText(openTrip.notes, i);
        });

        // Start background preloading remaining images when trip is opened
        const totalImages = openTrip.photoId.length;
        const alreadyLoaded = isMobile ? 1 : 3; // We loaded 1 (mobile) or 3 (desktop) initially
        for (let i = alreadyLoaded; i < totalImages; i++) {
          if (openTrip.photoBufferLocal[i] === 0) {
            loadBufferImage(
              openTrip.photoId[i],
              openTrip,
              i,
              SMALLIMAGERESOLUTION,
              'local',
            );
          }
        }
      }

      // Turn on scroll buttons
      if (openTrip && openTrip.files) {
        adjustScrollBtnVisability(
          leftButton,
          rightButton,
          openTrip.index,
          openTrip.files.length,
        );
      }
    } else {
      // Icon is up, change to down, Close accordion section
      closeAccordionItem(svg_parent);
    }

    /* remove modal window and it's action buttons*/
    modal.style.display = 'none';
    noteInput.style.display = 'none';
    saveButton.style.display = 'none';
  });
}

// Load trips for a given year
function loadTripsYear(itemYear) {
  // Close any open trip accordions before loading new year
  const openItems = document.querySelectorAll('.item.open');
  openItems.forEach(closeAccordionItem);
  // Get parent of SVG element (<div class="year")
  const svg_parent = itemYear.parentNode;
  const itemParentNodeID = svg_parent.id;

  // Check if trips for this year are already cached
  if (yearTripsCache[itemParentNodeID]) {
    // Restore cached HTML - re-insert wrapper divs into the DOM after the year div
    const cachedHtml = yearTripsCache[itemParentNodeID];
    let insertAfterEl = svg_parent;

    cachedHtml.forEach((html) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newEl = tempDiv.firstElementChild;
      insertAfterEl.insertAdjacentElement('afterend', newEl);
      insertAfterEl = newEl; // Advance so next item is inserted after this one

      const item = newEl.querySelector('.item');
      if (!item) return;

      // Re-wire open/close button
      const openBtn = item.querySelector('.icon');
      if (openBtn) wireOpenCloseBtn(openBtn);

      // Re-wire scroll buttons
      const scrollLeftBtn = item.querySelector('.btn--left');
      const scrollRightBtn = item.querySelector('.btn--right');
      const photoImgs = item.querySelectorAll('.photo');

      if (photoImgs[0]) {
        const tripIndex = helpers.getTripNumber(photoImgs[0].alt);
        if (scrollLeftBtn) wireScrollLeftClick(scrollLeftBtn, tripIndex);
        if (scrollRightBtn) wireScrollRtClick(scrollRightBtn, tripIndex);

        // Re-wire photo container touch (mobile)
        if (isMobile) {
          const photoContainer = item.querySelector('.photo-container');
          if (photoContainer)
            wirePhotoContainerTouch(photoContainer, tripIndex);
        }
      }

      // Re-wire photo clicks
      photoImgs.forEach((img) => {
        wireImageClick(img);
        if (isMobile) wireImageTouch(img);
      });
    });

    return;
  }

  // Add elemet to array for last year [1000, trips.length]
  let groupInfo = helpers.getYearGroupInfo(window.tripsList);
  groupInfo.push([10000, window.tripsList.length]);

  // Find index of year that was clicked (compare as string)
  const index = groupInfo.findIndex((pair) => pair[0] === itemParentNodeID);

  // Determine range of trips in clicked year
  const first = groupInfo[index][1];
  const last = groupInfo[index + 1][1] - 1;
  const yearGroup = groupInfo[index][0];

  loadTripsAndPhotos(window.tripsList, first, last, yearGroup);
}

function unloadTripsYear(tripYear) {
  const yearId = tripYear.id;

  // Cache the HTML before removing
  if (!yearTripsCache[yearId]) {
    const tripsHtml = [];
    let nextEl = tripYear.nextElementSibling;

    // displayItem wraps items in a div, so we need to look at firstElementChild
    while (
      nextEl &&
      nextEl.firstElementChild &&
      nextEl.firstElementChild.className === 'item'
    ) {
      tripsHtml.push(nextEl.outerHTML);
      nextEl = nextEl.nextElementSibling;
    }

    if (tripsHtml.length > 0) {
      yearTripsCache[yearId] = tripsHtml;
    }
  }

  // Remove trips from DOM (remove wrapper divs)
  while (
    tripYear.nextElementSibling &&
    tripYear.nextElementSibling.className != 'year'
  ) {
    tripYear.nextElementSibling.remove();
  }
}

// Set up event listeners for year Open (^) buttons
function wireOpenBtnYear(item) {
  item.addEventListener('click', function () {
    const childPath = item.firstElementChild;
    const svg_parent = item.parentNode;
    const isClosed = childPath.getAttributeNS(null, 'd') === 'M19 9l-7 7-7-7';

    if (isClosed) {
      // Opening a year accordion

      // Close all other year accordions and remove their trips
      const allYears = document.querySelectorAll('.year');
      allYears.forEach((yearEl) => {
        if (yearEl !== svg_parent && yearEl.classList.contains('open')) {
          yearEl.classList.remove('open');
          const iconYear = yearEl.querySelector('.iconYear');
          if (iconYear && iconYear.firstElementChild) {
            iconYear.firstElementChild.setAttribute('d', 'M19 9l-7 7-7-7');
          }
          // Remove all trip items that follow this year
          unloadTripsYear(yearEl);
        }
      });

      // Close all trip accordions across entire document
      const allItems = document.querySelectorAll('.item.open');
      allItems.forEach((tripItem) => {
        tripItem.className = 'item';
        const icon = tripItem.querySelector('.icon');
        if (icon && icon.firstElementChild) {
          icon.firstElementChild.setAttribute('d', 'M19 9l-7 7-7-7');
        }
        const rightButton = tripItem.getElementsByClassName('btn--right');
        const leftButton = tripItem.getElementsByClassName('btn--left');
        if (rightButton[0])
          rightButton[0].setAttribute('class', 'hide btn btn--right');
        if (leftButton[0])
          leftButton[0].setAttribute('class', 'hide btn btn--left');
      });

      // Open the clicked year accordion and load trips
      svg_parent.classList.add('open');
      childPath.setAttribute('d', 'M5 15l7-7 7 7');
      loadTripsYear(item);
    } else {
      // Closing a year accordion
      svg_parent.classList.remove('open');
      childPath.setAttribute('d', 'M19 9l-7 7-7-7');
      unloadTripsYear(svg_parent);
    }
    /* remove modal window and it's action buttons*/
    modal.style.display = 'none';
    noteInput.style.display = 'none';
    saveButton.style.display = 'none';
  });
}
/////////////////////////////////////////////////////
// Code for modal window with enlarged image
/////////////////////////////////////////////////////
const modal = document.getElementById('myModal');
const modalImg = document.getElementById('img01');
const noteInput = document.getElementById('myInput');
const photoImgs = document.querySelectorAll('.photo');
const saveButton = document.getElementsByClassName('btn-saveNote')[0];
const noteText = document.getElementsByClassName('imageNoteText')[0];
const modalContainer = document.getElementsByClassName('modalContainer')[0];
const spinner = document.getElementById('spinner');

// Initialize touch handlers for modal
wireModalTouch();

/*Set up Event handlers for clickinng on an image*/
// Attach click and touch handlers to all .photo images once at startup
photoImgs.forEach((item) => {
  wireImageClick(item);
});

function wireImageClick(item) {
  item.addEventListener('click', function () {
    modalImg.src = this.src;
    modalImg.alt = this.alt;

    // Get the trip data for selected trip
    const trip = window.tripsList[helpers.getTripNumber(modalImg.alt)];
    // Get index of displayed photo and use to get rest of information
    const file_index = getImageIndex(modalImg.alt);

    updateModalInfo(modal, modalImg, trip, file_index);

    // Hide the scroll buttons — traverse up through photo-wrapper and photo-container
    // to reach hidden-box regardless of nesting depth
    const hiddenBox = item.closest('.hidden-box') || item.closest('.item');
    if (!hiddenBox) return;

    const rightButton = hiddenBox.getElementsByClassName('btn--right');
    const leftButton = hiddenBox.getElementsByClassName('btn--left');

    if (rightButton[0])
      rightButton[0].setAttribute('class', 'hide btn btn--right');
    if (leftButton[0])
      leftButton[0].setAttribute('class', 'hide btn btn--left');
  });
}
// Touch event handlers for modal images
function wireImageTouch(item) {
  let startX = 0;
  let startY = 0;
  let moved = false;

  item.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      moved = false;
    },
    { passive: true },
  );

  item.addEventListener(
    'touchmove',
    (e) => {
      // Only mark as moved if significant movement (more than 10px)
      const diffX = Math.abs(startX - e.touches[0].clientX);
      const diffY = Math.abs(startY - e.touches[0].clientY);
      if (diffX > 10 || diffY > 10) {
        moved = true;
      }
    },
    { passive: true },
  );

  item.addEventListener(
    'touchend',
    (e) => {
      // Only handle taps (not swipes) - open modal
      if (!moved) {
        // Small delay to ensure this doesn't interfere with container handler
        setTimeout(() => {
          item.click();
        }, 10);
      }
      // Swipes are handled by wirePhotoContainerTouch
    },
    { passive: true },
  );
}

// Set up event listeners for scroll left  buttons
const scrollLeftBtns = document.querySelectorAll('.modalBtn--left');
wireScrollModalLeftClick(scrollLeftBtns[scrollLeftBtns.length - 1]);

// Set up event listeners for scroll right  buttons
const scrollRightBtns = document.querySelectorAll('.modalBtn--right');
wireScrolllModalRtClick(scrollRightBtns[scrollRightBtns.length - 1]);

// Modal touch events
function wireModalTouch() {
  const modalContent = document.getElementById('img01');
  let startX = 0;
  let moved = false;

  modalContent.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
      moved = false;
    },
    { passive: true },
  );

  modalContent.addEventListener(
    'touchmove',
    (e) => {
      moved = true;
      // Don't preventDefault - let browser handle
    },
    { passive: true },
  );

  modalContent.addEventListener(
    'touchend',
    (e) => {
      if (!moved) {
        return; // Was just a tap, not a swipe
      }

      const diff = startX - e.changedTouches[0].clientX;
      if (diff > 50) {
        // Swipe left - go to next image
        const rightBtns = document.querySelectorAll('.modalBtn--right');
        const rightBtn = rightBtns[rightBtns.length - 1];
        if (rightBtn && !rightBtn.classList.contains('hide')) {
          rightBtn.click();
        }
      } else if (diff < -50) {
        // Swipe right - go to previous image
        const leftBtns = document.querySelectorAll('.modalBtn--left');
        const leftBtn = leftBtns[leftBtns.length - 1];
        if (leftBtn && !leftBtn.classList.contains('hide')) {
          leftBtn.click();
        }
      }
    },
    { passive: true },
  );
}

// Load photo to left of current one, unless at end of list
function wireScrollModalLeftClick(item) {
  item.addEventListener('click', async function () {
    const tripNumber = helpers.getTripNumber(modalImg.alt);
    const trip = window.tripsList[tripNumber];
    const file_index = getImageIndex(modalImg.alt);
    const numPhotos = trip.dates.length;
    if (file_index > 0) {
      const newFileIndex = parseInt(file_index) - 1;
      // On-demand image loading (full size for modal)
      if (!trip.photoBufferModal[newFileIndex]) {
        spinner.style.display = 'block';
        await loadBufferImage(
          trip.photoId[newFileIndex],
          trip,
          newFileIndex,
          1200,
          'modal',
        );
        spinner.style.display = 'none';
      }
      modalContainer.style.display = 'none';
      updateModalInfo(modal, modalImg, trip, newFileIndex);
      modalContainer.style.display = 'block';
      const newAlt = `${tripNumber},${newFileIndex}`;
      modalImg.alt = newAlt;
      // Preload previous image (full size)
      if (newFileIndex > 0 && !trip.photoBufferModal[newFileIndex - 1]) {
        loadBufferImage(
          trip.photoId[newFileIndex - 1],
          trip,
          newFileIndex - 1,
          1200,
          'modal',
        );
      }
      // Preload next image (full size)
      if (
        newFileIndex < numPhotos - 1 &&
        !trip.photoBufferModal[newFileIndex + 1]
      ) {
        loadBufferImage(
          trip.photoId[newFileIndex + 1],
          trip,
          newFileIndex + 1,
          1200,
          'modal',
        );
      }
    }
  });
}
// Load photo to right of current one, unless at end of list
function wireScrolllModalRtClick(item) {
  item.addEventListener('click', async function () {
    const tripNumber = helpers.getTripNumber(modalImg.alt);
    const trip = window.tripsList[tripNumber];
    const file_index = getImageIndex(modalImg.alt);
    const numPhotos = trip.dates.length;
    if (file_index < numPhotos - 1) {
      const newFileIndex = parseInt(file_index) + 1;
      // On-demand image loading (full size for modal)
      if (!trip.photoBufferModal[newFileIndex]) {
        spinner.style.display = 'block';
        await loadBufferImage(
          trip.photoId[newFileIndex],
          trip,
          newFileIndex,
          1200,
          'modal',
        );
        spinner.style.display = 'none';
      }
      modalImg.style.display = 'none';
      updateModalInfo(modal, modalImg, trip, newFileIndex);
      modalImg.style.display = 'block';
      const newAlt = `${tripNumber},${newFileIndex}`;
      modalImg.alt = newAlt;
      // Preload next image (full size)
      if (
        newFileIndex < numPhotos - 1 &&
        !trip.photoBufferModal[newFileIndex + 1]
      ) {
        loadBufferImage(
          trip.photoId[newFileIndex + 1],
          trip,
          newFileIndex + 1,
          1200,
          'modal',
        );
      }
      // Preload previous image (full size)
      if (newFileIndex > 0 && !trip.photoBufferModal[newFileIndex - 1]) {
        loadBufferImage(
          trip.photoId[newFileIndex - 1],
          trip,
          newFileIndex - 1,
          1200,
          'modal',
        );
      }
    }
    // Show guestbook after scrolling (desktop only)
    if (guestbookShown === false && !isMobile) {
      const guestBook = document.getElementById('guestBook');
      guestBook.style.display = 'inline-block';
      guestbookShown = true;
    }
  });
}
// Adjust modal scroll button visibility
function adjustScrollModalBtnVisability(
  leftButton,
  rightButton,
  startIndex,
  nItems,
) {
  // Turn both on
  rightButton[0].setAttribute('class', 'btn modalBtn--right');
  leftButton[0].setAttribute('class', 'btn modalBtn--left');

  if (startIndex === 0) {
    leftButton[0].setAttribute('class', 'hide btn modalBtn--left');
  }

  if (startIndex >= nItems - 1) {
    rightButton[0].setAttribute('class', 'hide btn modalBtn--right');
  }
}

// Trip and Trip index are stored in image "alt" string as comma separated "tripNum, index"
// These functions allow us to easily access them
// getTripNumber function removed; now using helpers.getTripNumber
export function getImageIndex(altStr) {
  return parseInt(altStr.split(',')[1]);
}
window.getImageIndex = getImageIndex;

function updateModalInfo(modal, modalImg, trip, file_index) {
  const date_displayed = trip.dates[file_index];

  let altitude_displayed = trip.altitudes[file_index];
  let latitude_displayed = trip.latatudes[file_index];
  let longtitude_displayed = trip.longitudes[file_index];

  if (altitude_displayed === null) {
    altitude_displayed = 0;
  }
  if (latitude_displayed === null) {
    latitude_displayed = 0;
  }
  if (longtitude_displayed === null) {
    longtitude_displayed = 0;
  }

  const globe_icon = document.getElementById('globeIcon');
  // console.log('latitude_displayed***', latitude_displayed);

  // Display globe if we have location data
  if (latitude_displayed === 0) {
    globe_icon.setAttribute('hidden', 'hidden');
  } else {
    globe_icon.removeAttribute('hidden');
  }

  noteInput.placeholder = trip.notes[file_index];
  noteInput.value = trip.notes[file_index];
  noteText.textContent = trip.notes[file_index];

  /* Chose which modal box to use */

  spinner.style.display = 'block';

  // Load a high resolution copy of modal photo
  const promise = getHighResolutionPhoto(trip, file_index);
  promise.then(function () {
    modalImg.src = `data:image/jpeg;base64,${trip.photoBufferModal[file_index]}`;
    if (
      file_index === 0 &&
      trip.photoBufferModal.length > 2 &&
      !trip.photoBufferModal[2]
    ) {
      loadBufferImage(trip.photoId[2], trip, 2, 1200, 'modal');
    }

    // Figure out what size box we need to contain image
    const ratioPixWdivH = trip.widths[file_index] / trip.heights[file_index];

    modal.style.display = 'block';

    // Set up based on how wide the window is
    // Use viewport width for better mobile sizing
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const PIXELS_PER_REM = 10;

    // Caption height in pixels
    const captionHeightPx = 60;
    const noteSpaceVRem = captionHeightPx / PIXELS_PER_REM;

    // Calculate available space
    const availableHeightRem =
      viewportHeight / PIXELS_PER_REM - noteSpaceVRem - 2; // 2rem padding

    let widthMaxRem;
    if (viewportWidth > 1220) {
      widthMaxRem = 118;
    } else if (viewportWidth > 900) {
      widthMaxRem = 90;
    } else if (viewportWidth > 600) {
      widthMaxRem = 60;
    } else {
      // Mobile: use most of viewport width
      widthMaxRem = (viewportWidth * 0.95) / PIXELS_PER_REM;
    }

    // Calculate dimensions based on aspect ratio
    if (ratioPixWdivH >= 1) {
      // Landscape or square image
      const calculatedHeight = widthMaxRem / ratioPixWdivH + noteSpaceVRem;

      // Check if it fits in viewport height
      if (calculatedHeight > availableHeightRem) {
        // Height constrained - scale down width
        const imageHeightRem = availableHeightRem - noteSpaceVRem;
        widthMaxRem = imageHeightRem * ratioPixWdivH;
      }

      modal.style.width = `${widthMaxRem}rem`;
      modal.style.height = `${widthMaxRem / ratioPixWdivH + noteSpaceVRem}rem`;
    } else {
      // Portrait image
      const imageHeightRem = widthMaxRem / ratioPixWdivH;
      const totalHeightRem = imageHeightRem + noteSpaceVRem;

      // Check if it fits in viewport height
      if (totalHeightRem > availableHeightRem) {
        // Height constrained - scale down
        const scaledImageHeight = availableHeightRem - noteSpaceVRem;
        widthMaxRem = scaledImageHeight * ratioPixWdivH;
        modal.style.width = `${widthMaxRem}rem`;
        modal.style.height = `${availableHeightRem}rem`;
      } else {
        modal.style.width = `${widthMaxRem}rem`;
        modal.style.height = `${totalHeightRem}rem`;
      }
    }

    spinner.style.display = 'none';

    // Show/Hide buttons base on where we are in set
    const numPhotos = trip.dates.length;
    adjustScrollModalBtnVisability(
      scrollLeftBtns,
      scrollRightBtns,
      file_index,
      numPhotos,
    );
  });
}

// Loads a higher resolution photo
async function getHighResolutionPhoto(trip, index) {
  // Use modal buffer for high-res modal images
  if (!trip.photoBufferModal[index]) {
    await loadBufferImage(trip.photoId[index], trip, index, 1200, 'modal');
  }
}

// When the user clicks on [X], close the modal
const close_modal = document.getElementsByClassName('close')[0];
close_modal.onclick = function () {
  modal.style.display = 'none';

  // Re-establish active accordion element scroll buttons
  const openItem = document.getElementsByClassName('item open');
  if (!openItem || !openItem[0]) return;

  // Use openTrip.index for button visibility
  const photos = openItem[0].getElementsByClassName('photo');
  let photoAlt, tripNumber, openTrip, rightButton, leftButton, nItems;
  if (photos[0]) {
    photoAlt = photos[0].alt;
    tripNumber = helpers.getTripNumber(photoAlt);
    openTrip = window.tripsList[tripNumber];
    rightButton = openItem[0].getElementsByClassName('btn--right');
    leftButton = openItem[0].getElementsByClassName('btn--left');
    nItems = openTrip ? openTrip.files.length : 1;
  } else {
    rightButton = openItem[0].getElementsByClassName('btn--right');
    leftButton = openItem[0].getElementsByClassName('btn--left');
    nItems = 1;
  }

  // Always start with both buttons visible
  rightButton[0].setAttribute('class', 'btn btn--right');
  leftButton[0].setAttribute('class', 'btn btn--left');

  const photosPerView = isMobile ? 1 : 3;

  // If not enough photos to scroll, hide both buttons
  if (nItems <= photosPerView) {
    leftButton[0].setAttribute('class', 'hide btn btn--left');
    rightButton[0].setAttribute('class', 'hide btn btn--right');
    return;
  }

  // Hide left button if at first image
  if (openTrip && openTrip.index === 0) {
    leftButton[0].setAttribute('class', 'hide btn btn--left');
  }

  // Hide right button if at last image (mobile) or last scrollable set (desktop)
  if (isMobile) {
    if (openTrip && openTrip.index >= nItems - 1) {
      rightButton[0].setAttribute('class', 'hide btn btn--right');
    }
  } else {
    if (openTrip && openTrip.index >= nItems - photosPerView) {
      rightButton[0].setAttribute('class', 'hide btn btn--right');
    }
  }
};

// When the user clicks on [X], close the map
// Leaflet map initialization
const L = require('leaflet');
let myMap = L.map('map').setView([0, 0], 13);

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
}).addTo(myMap);

// Setup globe icon click event handler
const globes = document.querySelectorAll('.globe');
globes.forEach((item) => {
  item.addEventListener('click', function () {
    const modalImg = document.getElementById('img01');
    const getImageIndex =
      window.getImageIndex || ((altStr) => parseInt(altStr.split(',')[1]));
    const trip = window.tripsList[helpers.getTripNumber(modalImg.alt)];
    const file_index = getImageIndex(modalImg.alt);
    let altitude_displayed = trip.altitudes[file_index];
    let latitude_displayed = trip.latatudes[file_index];
    let longtitude_displayed = trip.longitudes[file_index];
    if (altitude_displayed === null) altitude_displayed = 0;
    if (latitude_displayed === null) latitude_displayed = 0;
    if (longtitude_displayed === null) longtitude_displayed = 0;
    const modalMap = document.getElementById('mapX');
    modalMap.style.display = 'block';
    myMap.invalidateSize();
    myMap.setView([latitude_displayed, longtitude_displayed], 16);
    L.marker([latitude_displayed, longtitude_displayed])
      .addTo(myMap)
      .bindPopup(`Altitude(ft): ${(altitude_displayed * 3.28084).toFixed(1)}`)
      .openPopup();
  });
});

// Setup map modal close handler
const modalMap = document.getElementById('mapX');
const close_modalMap = document.getElementsByClassName('closeMap')[0];
if (close_modalMap && modalMap) {
  close_modalMap.onclick = function () {
    modalMap.style.display = 'none';
  };
}

// Event listeners for info button
const infos = document.querySelectorAll('.info');
infos.forEach(infoClick);
function infoClick(item) {
  item.addEventListener('click', function () {
    // console.log('Click on info', this);

    // Get the trip data for selected trip
    const trip = window.tripsList[helpers.getTripNumber(modalImg.alt)];
    // console.log('trip*', trip);

    // Get index of displayed photo and use to get rest of information
    const file_index = getImageIndex(modalImg.alt);
    // console.log('file_index', file_index);
    const date_displayed = trip.dates[file_index];
    const file_name = trip.files[file_index];
    let altitude_displayed = trip.altitudes[file_index];
    let latitude_displayed = trip.latatudes[file_index];
    let longtitude_displayed = trip.longitudes[file_index];
    let notes_displayed = trip.notes[file_index];

    if (altitude_displayed === null) {
      altitude_displayed = 0;
    }
    if (latitude_displayed === null) {
      latitude_displayed = 0;
    }
    if (longtitude_displayed === null) {
      longtitude_displayed = 0;
    }

    // Display information on alert box
    alert(
      `Trip Name: ${
        trip.name
      } \nDate:  ${date_displayed} \nFile name: ${file_name} \nAltitude(ft): ${(
        altitude_displayed * 3.28084
      ).toFixed(1)} \nLatitude: ${latitude_displayed.toFixed(
        5,
      )} \nLongitude: ${longtitude_displayed.toFixed(5)}
      \nNotes: ${notes_displayed}`,
    );
  });
}

// Event listeners for click on note icon
const notes = document.querySelectorAll('.note');
notes.forEach(notesClick);
function notesClick(item) {
  item.addEventListener('click', function () {
    noteInput.style.display = 'block';
    saveButton.style.display = 'block';
    notes[0].style.display = 'none';
    noteText.style.display = 'none';
  });
}

// Save update note in Trips database
async function patchTripNote(notesNew, tripId) {
  const axiosFn = typeof axios === 'function' ? axios : axios.default;
  await axiosFn({
    method: 'patch',
    url: `${SERVERURL}/api/v1/trips/${tripId}`,

    data: {
      notes: notesNew,
    },
  });
}

// Save update note in Trips database
async function patchTrip(tripUpdate, tripId) {
  const axiosFn = typeof axios === 'function' ? axios : axios.default;
  await axiosFn({
    method: 'patch',
    url: `${SERVERURL}/api/v1/trips/${tripId}`,

    data: tripUpdate,
  });
}

// Need access from sorter
window.patchTrip = patchTrip;

// When the user clicks on the save note "Save" button
saveButton.onclick = function () {
  // Get the trip data for selected trip (# is saved in .alt field)
  const tripData = window.tripsList[helpers.getTripNumber(modalImg.alt)];
  const file_index = getImageIndex(modalImg.alt);

  tripData.notes[file_index] = noteInput.value;
  // Update the note text value
  noteText.textContent = noteInput.value;

  // console.log('Click on note Save button');

  const tripId = tripData._id;
  // console.log('tripeId=', tripId);
  patchTripNote(tripData.notes, tripId);

  noteInput.style.display = 'none';
  saveButton.style.display = 'none';
  notes[0].style.display = 'block';
  noteText.style.display = 'block';
};

/////////////////////////////////////////////////////
// Code to build accordian items html based on trip data
/////////////////////////////////////////////////////

function insertAfter(newNode, referenceNode) {
  if (referenceNode.nextSibling) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  } else {
    referenceNode.parentNode.appendChild(newNode);
  }
}

// Photo container touch events
function wirePhotoContainerTouch(container, tripsIndex) {
  let startX = 0;
  let startY = 0;
  let moved = false;
  let isProcessing = false;
  let touchStartedOnPhoto = false;
  let isHorizontalSwipe = false;

  container.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      moved = false;
      isHorizontalSwipe = false;
      touchStartedOnPhoto = e.target.classList.contains('photo');
    },
    { passive: true },
  );

  container.addEventListener(
    'touchmove',
    (e) => {
      if (!touchStartedOnPhoto) return;

      if (!moved) {
        const diffX = Math.abs(startX - e.touches[0].clientX);
        const diffY = Math.abs(startY - e.touches[0].clientY);

        // Determine if this is a horizontal swipe
        if (diffX > 20 && diffX > diffY * 2) {
          moved = true;
          isHorizontalSwipe = true;
          // Prevent default to stop page scrolling/panning
          e.preventDefault();
        }
      } else if (isHorizontalSwipe) {
        // Continue preventing default during horizontal swipe
        e.preventDefault();
      }
    },
    { passive: false },
  ); // MUST be non-passive to call preventDefault

  container.addEventListener(
    'touchend',
    (e) => {
      if (!touchStartedOnPhoto) return;

      // If not moved enough, let the tap handler open the modal
      if (!moved) {
        return;
      }

      // Check if already processing
      if (isProcessing) {
        return;
      }

      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const absDiff = Math.abs(diff);

      // Require minimum swipe distance
      if (absDiff < 40) {
        return;
      }

      const hiddenBox = container.parentNode;
      isProcessing = true;

      setTimeout(() => {
        isProcessing = false;
      }, 500);

      if (diff > 0) {
        // Swipe left - advance
        const rightButton = hiddenBox.getElementsByClassName('btn--right')[0];
        if (rightButton && !rightButton.classList.contains('hide')) {
          rightButton.click();
        } else {
          isProcessing = false;
        }
      } else {
        // Swipe right - go back
        const leftButton = hiddenBox.getElementsByClassName('btn--left')[0];
        if (leftButton && !leftButton.classList.contains('hide')) {
          leftButton.click();
        } else {
          isProcessing = false;
        }
      }
    },
    { passive: true },
  );
}

// Construct a new item and insert into DOM
const displayItem = function (photoData, tripsIndex, yearGroup) {
  const containerItems = document.querySelector('.accordion');

  // Determine how many images to generate based on device type (set at startup)
  const numImages = isMobile ? 1 : 3;

  // Build image HTML dynamically
  let imagesHTML = '';
  for (let i = 0; i < numImages; i++) {
    const noteText = getNoteText(photoData.notes, i);
    imagesHTML += `
        <div class="photo-wrapper">
          <img
            class="photo"
            style="border-radius:12px;"
            src="data:image/jpeg;base64,${photoData.photoBufferLocal[i]}"
            alt="${tripsIndex},${i}"
          />
          <p class="photo-note">${noteText}</p>
        </div>`;
  }

  const newItemHTML = `<div class="item">
 
    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" ckass="footsteps width="30" height="30" viewBox="0 0 512 512"><title>Footsteps</title><path d="M200 246.84c8.81 58.62-7.33 90.67-52.91 97.41-50.65 7.49-71.52-26.44-80.33-85.06-11.85-78.88 16-127.94 55.71-131.1 36.14-2.87 68.71 60.14 77.53 118.75zM223.65 409.53c3.13 33.28-14.86 64.34-42 69.66-27.4 5.36-58.71-16.37-65.09-49.19s17.75-34.56 47.32-40.21 55.99-20.4 59.77 19.74zM312 150.83c-8.81 58.62 7.33 90.67 52.9 97.41 50.66 7.49 71.52-26.44 80.33-85.06 11.86-78.89-16-128.22-55.7-131.1-36.4-2.64-68.71 60.13-77.53 118.75zM288.35 313.53c-3.13 33.27 14.86 64.34 42 69.66 27.4 5.36 58.71-16.37 65.09-49.19s-17.75-34.56-47.32-40.22-55.99-20.4-59.77 19.75z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>
    
    <p class="destination">${photoData.name}</p>
  <p class="start-date">${helpers.formatDate(photoData.date)}</p>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round"
      stroke-width="2" d="M19 9l-7 7-7-7"" />
    </svg>
    <div class="hidden-box">
      <button class="hide btn btn--left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn-icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button class="hide btn btn--right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn-icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
      <div class="photo-container">
        ${imagesHTML}
      </div>
    </div>
    </div>`;

  // Add to bottom of groupYear accordian segment
  let newDiv = document.createElement('div');
  newDiv.innerHTML = newItemHTML;

  let referenceDiv = document.getElementById(yearGroup);

  let lastSibling = referenceDiv;

  // Move down until you find another yearElement or the end of the list
  while (
    lastSibling.nextElementSibling &&
    lastSibling.nextElementSibling.className != 'year'
  ) {
    lastSibling = lastSibling.nextElementSibling;
  }

  // Insert the new item below
  insertAfter(newDiv, lastSibling);

  // Set up event listeners for Open/Close buttons
  const openCloseBtns = document.querySelectorAll('.icon');

  // Add click function to the last .icon in array
  wireOpenCloseBtn(openCloseBtns[openCloseBtns.length - 1]); // Remove second parameter

  // Set up event listeners for scroll left  buttons
  const scrollLeftBtns = document.querySelectorAll('.btn--left');
  wireScrollLeftClick(scrollLeftBtns[scrollLeftBtns.length - 1], tripsIndex);

  // Set up event listeners for scroll right  buttons
  const scrollRightBtns = document.querySelectorAll('.btn--right');
  wireScrollRtClick(scrollRightBtns[scrollRightBtns.length - 1], tripsIndex);

  // Wire up touch events (mobile only)
  if (isMobile) {
    const photoContainer = newDiv.querySelector('.photo-container');
    if (photoContainer) {
      wirePhotoContainerTouch(photoContainer, tripsIndex);
    }
  }

  /*Set up Event handlers for clicking on an image*/
  const photoImgs = document.querySelectorAll('.photo');
  const photoImgsLength = photoImgs.length;
  const startIdx = photoImgsLength - numImages; // Get only the newly added images
  for (let i = startIdx; i < photoImgsLength; i++) {
    wireImageClick(photoImgs[i]); // removed unused second arg
    if (isMobile) wireImageTouch(photoImgs[i]);
  }
};

// Construct a new YEAR item and insert at bottom
const displayItemYear = function (year) {
  const containerItems = document.querySelector('.accordion');

  const newItemHTML = `<div class="year" id=${year}>
    <p class="dummy value">"x"</p>
    <p class="group-date">${year}</p>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="iconYear"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round"
      stroke-width="2" d="M19 9l-7 7-7-7"" />
    </svg>`;

  // Add to bottom of accordion
  containerItems.insertAdjacentHTML('beforeend', newItemHTML);

  // Set up event listeners for Open/ buttons
  const openBtns = document.querySelectorAll('.iconYear');

  // Adds the last .icon in array
  wireOpenBtnYear(openBtns[openBtns.length - 1]); // Remove second parameter
};

async function loadTripsAndPhotos(trips, beginIndex, endIndex, yearGroup) {
  // Load trips in small batches to avoid rate limiting
  const BATCH_SIZE = 3; // Load 3 trips at a time
  const BATCH_DELAY = 200; // Wait 200ms between batches

  for (
    let batchStart = beginIndex;
    batchStart < endIndex;
    batchStart += BATCH_SIZE
  ) {
    const batchEnd = Math.min(batchStart + BATCH_SIZE, endIndex);
    const batchPromises = [];

    // Load photos for this batch in parallel
    for (let index = batchStart; index < batchEnd; index++) {
      batchPromises.push(loadPhotosForTrip(trips[index], index));
    }

    await Promise.all(batchPromises);

    // Display in sorted order AFTER all photos in the batch are loaded
    for (let index = batchStart; index < batchEnd; index++) {
      displayItem(trips[index], index, yearGroup);
    }

    // Wait before loading next batch (unless this was the last batch)
    if (batchEnd < endIndex) {
      await new Promise((resolve) => setTimeout(resolve, BATCH_DELAY));
    }
  }
}

// Load photos for a trip into its buffers (display is handled separately)
async function loadPhotosForTrip(trip, index) {
  trip.photoBufferLocal = [];
  trip.photoBufferModal = [];
  for (let i = 0; i < trip.photoId.length; i++) {
    trip.photoBufferLocal.push(0);
    trip.photoBufferModal.push(0);
  }

  // Only load images needed for INITIAL DISPLAY
  // Mobile: 1 image, Desktop: 3 images
  const imagesToLoadNow = isMobile ? 1 : 3;

  // Load images in parallel for this trip
  const loadPromises = [];
  for (let i = 0; i < Math.min(imagesToLoadNow, trip.photoId.length); i++) {
    loadPromises.push(
      loadBufferImage(trip.photoId[i], trip, i, SMALLIMAGERESOLUTION, 'local'),
    );
  }

  await Promise.all(loadPromises);
}

// Update loadBufferImage to support buffer type
export function loadBufferImage(
  photoID,
  trip,
  imageIndex,
  resolution,
  bufferType = 'local',
) {
  return new Promise(function (resolve) {
    fetch(`${SERVERURL}/api/v1/photos/${photoID}?size=${resolution}`)
      .then(function (response) {
        if (response.status === 429) {
          console.error('Rate limit exceeded (HTTP 429) for photoID:', photoID);
          if (bufferType === 'modal') trip.photoBufferModal[imageIndex] = null;
          else trip.photoBufferLocal[imageIndex] = null;
          resolve('Rate limited');
          return;
        }
        if (!response.ok) {
          console.error(
            'Photo fetch failed:',
            response.status,
            response.statusText,
          );
          if (bufferType === 'modal') trip.photoBufferModal[imageIndex] = null;
          else trip.photoBufferLocal[imageIndex] = null;
          resolve('Fetch failed');
          return;
        }
        return response.json().catch(function (err) {
          response.text().then(function (text) {
            console.error('Photo fetch returned non-JSON:', text);
            if (bufferType === 'modal')
              trip.photoBufferModal[imageIndex] = null;
            else trip.photoBufferLocal[imageIndex] = null;
            resolve('Non-JSON response');
          });
        });
      })
      .then(function (data) {
        if (!data || !data.data || !data.data.img || !data.data.img.data) {
          return;
        }
        const photoImage = data.data.img.data;
        const u8 = new Uint8Array(photoImage);
        const b64 = Buffer.from(u8).toString('base64');
        if (bufferType === 'modal') trip.photoBufferModal[imageIndex] = b64;
        else trip.photoBufferLocal[imageIndex] = b64;
        resolve('It worked');
      })
      .catch(function (err) {
        console.error('getPhotoData ERROR', err);
        if (bufferType === 'modal') trip.photoBufferModal[imageIndex] = null;
        else trip.photoBufferLocal[imageIndex] = null;
        resolve('Fetch error');
      });
  });
}

// Need access from sorter (non-module script)
window.loadBufferImage = loadBufferImage;

async function getTripData(tripID) {
  try {
    spinner.style.display = 'block'; // Show spinner while loading
    const response = await fetch(`${SERVERURL}/api/v1/trips?sort=-date`);
    const data = await response.json();
    window.tripsList = data.data.trips;

    // Ensure buffers and index are initialized for each trip
    window.tripsList.forEach((trip) => {
      trip.photoBufferLocal = [];
      trip.photoBufferModal = [];
      trip.index = 0; // Initialize index to 0
    });

    const groupInfo = helpers.getYearGroupInfo(window.tripsList);

    // Display all year items
    const lGroup = groupInfo.length;
    for (let index = 0; index < lGroup; index++) {
      displayItemYear(groupInfo[index][0]);
    }

    // Load trips below first Year
    const yearGroup = groupInfo[0][0];
    await loadTripsAndPhotos(
      window.tripsList,
      groupInfo[0][1],
      groupInfo[1][1],
      yearGroup,
    );

    spinner.style.display = 'none'; // Hide spinner after loading

    // Open only the first year accordion on startup
    const allYears = document.querySelectorAll('.year');
    if (allYears[0]) {
      allYears[0].classList.add('open');
      // Set arrow to up for first year
      const iconYear = allYears[0].querySelector('.iconYear');
      if (iconYear && iconYear.firstElementChild) {
        iconYear.firstElementChild.setAttribute('d', 'M5 15l7-7 7 7');
      }
    }
    // Ensure all trip items are closed
    const allItems = document.querySelectorAll('.item');
    allItems.forEach((item) => (item.className = 'item'));
  } catch (err) {
    console.error('getTripData ERROR', err);
    spinner.style.display = 'none';
  }
}
